import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_LOCATION_CATEGORY_LIST = {
    type: 'LOCATION_CATEGORY_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let ACTION_LOCATION_CATEGORY_VIEW = {
    type: 'LOCATION_CATEGORY_VIEW',
    payload: {
        name: '',
    },
};

let ACTION_LOCATION_CATEGORY_SELECT = {
    type: 'LOCATION_CATEGORY_SELECT',
    payload: [],
};

let callLocationCategoryListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/location-categories?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_LOCATION_CATEGORY_LIST.payload.rows = data.rows
        ACTION_LOCATION_CATEGORY_LIST.payload.total = data.total
        ACTION_LOCATION_CATEGORY_LIST.payload.pagination = data.pagination
        dispatch(ACTION_LOCATION_CATEGORY_LIST)
    })
}

let callLocationCategoryViewGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/location-categories/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_LOCATION_CATEGORY_VIEW.payload.name = data.name
        dispatch(ACTION_LOCATION_CATEGORY_VIEW)
    })
}

let callLocationCategoryPost = (data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/location-categories', data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callLocationCategoryPut = (id, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.put('/location-categories/' + id, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callLocationCategoryClearView = () => (dispatch) => {
    ACTION_LOCATION_CATEGORY_VIEW.payload.name = ''
    dispatch(ACTION_LOCATION_CATEGORY_VIEW)
}

let callLocationCategoryDelete = (id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/location-categories/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callLocationCategorySelectGet = (id) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/location-categories/select').then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_LOCATION_CATEGORY_SELECT.payload = data
        dispatch(ACTION_LOCATION_CATEGORY_SELECT)
    })
}

export { callLocationCategoryListGet, callLocationCategoryViewGet, callLocationCategoryPost, callLocationCategoryPut, callLocationCategoryClearView, callLocationCategoryDelete, callLocationCategorySelectGet, ACTION_LOCATION_CATEGORY_LIST, ACTION_LOCATION_CATEGORY_VIEW, ACTION_LOCATION_CATEGORY_SELECT }